import React from "react";

import LoadingAnimation from "../../Layout/LoadingAnimations/loading";
import Typography from "../../Typography";

import request from "../../../utils/request"

import "./index.scss";

export default class CitySearcher extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            loadingCities: false,
            cities: [],
            displayCities: false
        }
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClick, false);
    }
    
    componentWillUnmount() {
        document.removeEventListener('click', this.handleClick, false);
    }

    handleClick = (e) => {
        if (this.node){
          if ( !this.node.contains(e.target) ){
            this.setState({ displayCities: false })
          }
        }
      }

    updateCities = (city) => {
        this.props.changeCity(city);

        let country = 'FR';
        if(this.props.config && this.props.config.cityCountries){
            country = this.props.config.cityCountries;
        }

        if (city.length >= 3) {
            this.setState({ loadingCities: true }, () => {
                request({
                    url: "https://connect-dev.spotlio.com/koedia/static-data/cities?country="+country+"&city=" + city,
                    method: "GET"
                })
                .then((res) => {
                    this.setState({ loadingCities: false, cities: res.data.City, displayCities: true });
                })
            })
        }
    }

    render(){
        const { state, props, updateCities } = this;
        const { cities, loadingCities, displayCities } = state;
        const { city, changeCity } = props;

        return(
            <div ref={node => this.node = node} className="city">
                <Typography className="h300bold">City</Typography>
                <div className="cityInput">
                    <input value={city.name ? city.name : city} onChange={(e)=>{ updateCities(e.target.value) }} placeholder="Type city here"/>
                    {loadingCities && <LoadingAnimation size={16}/>}
                </div>
            
                {displayCities && <div className="cities">
                    {cities.map((city, index) => {
                        return <p onClick={()=>this.setState({ displayCities: false }, () => { changeCity(city) }) } key={"city " +  index}>
                            {city.name  + " (" +  city.country + ")"}
                        </p>
                    })}
                </div> }
            </div>
        )
    }
}